import { render, staticRenderFns } from "./recipient-address.vue?vue&type=template&id=673d1914"
import script from "./recipient-address.vue?vue&type=script&lang=js"
export * from "./recipient-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports